/* global $ */
var spin = $('.spritespin')
var container = $('#glace')
var body = $('body')
var windowHeight = $(window).height()
var windowWidth = $(window).width()

var currentMousePos = 0
var target = 0

container.mouseenter(function (event) {
  currentMousePos = event.pageX
  target = parseInt(currentMousePos / windowWidth * 42)

  container.spritespin({
    frame: target
  })
})

// to avoid blinks on the canevas when overing the nav
container.mouseleave(function (event) {
  currentMousePos = event.pageX
  if (currentMousePos > 500) {
    // This code will never run.
    body.css('background-image', 'url("./assets/mr_quinzequinze.gold/41.jpg")')
  } else {
    body.css('background-image', 'url("./assets/mr_quinzequinze.gold/00.jpg")')
  }
})

$(window).resize(function () {
  body.css('background-image', 'url("")')
// var windowHeight = $(window).height()
// var windowWidth = $(window).width()
// this.width(windowWidth).height(windowHeight)
})

container.spritespin({
  source: [
    './assets/mr_quinzequinze.gold/00.jpg',
    './assets/mr_quinzequinze.gold/01.jpg',
    './assets/mr_quinzequinze.gold/02.jpg',
    './assets/mr_quinzequinze.gold/03.jpg',
    './assets/mr_quinzequinze.gold/04.jpg',
    './assets/mr_quinzequinze.gold/05.jpg',
    './assets/mr_quinzequinze.gold/06.jpg',
    './assets/mr_quinzequinze.gold/07.jpg',
    './assets/mr_quinzequinze.gold/08.jpg',
    './assets/mr_quinzequinze.gold/09.jpg',
    './assets/mr_quinzequinze.gold/10.jpg',
    './assets/mr_quinzequinze.gold/11.jpg',
    './assets/mr_quinzequinze.gold/12.jpg',
    './assets/mr_quinzequinze.gold/13.jpg',
    './assets/mr_quinzequinze.gold/14.jpg',
    './assets/mr_quinzequinze.gold/15.jpg',
    './assets/mr_quinzequinze.gold/16.jpg',
    './assets/mr_quinzequinze.gold/17.jpg',
    './assets/mr_quinzequinze.gold/18.jpg',
    './assets/mr_quinzequinze.gold/19.jpg',
    './assets/mr_quinzequinze.gold/20.jpg',
    './assets/mr_quinzequinze.gold/21.jpg',
    './assets/mr_quinzequinze.gold/22.jpg',
    './assets/mr_quinzequinze.gold/23.jpg',
    './assets/mr_quinzequinze.gold/24.jpg',
    './assets/mr_quinzequinze.gold/25.jpg',
    './assets/mr_quinzequinze.gold/26.jpg',
    './assets/mr_quinzequinze.gold/27.jpg',
    './assets/mr_quinzequinze.gold/28.jpg',
    './assets/mr_quinzequinze.gold/29.jpg',
    './assets/mr_quinzequinze.gold/30.jpg',
    './assets/mr_quinzequinze.gold/31.jpg',
    './assets/mr_quinzequinze.gold/32.jpg',
    './assets/mr_quinzequinze.gold/33.jpg',
    './assets/mr_quinzequinze.gold/34.jpg',
    './assets/mr_quinzequinze.gold/35.jpg',
    './assets/mr_quinzequinze.gold/36.jpg',
    './assets/mr_quinzequinze.gold/37.jpg',
    './assets/mr_quinzequinze.gold/38.jpg',
    './assets/mr_quinzequinze.gold/39.jpg',
    './assets/mr_quinzequinze.gold/40.jpg',
    './assets/mr_quinzequinze.gold/41.jpg'
  ],
  renderer: 'canvas',
  width: windowWidth,
  sense: 1,
  height: windowHeight,
  frame: 0,
  wrap: false,
  loop: false,
  animate: false,
  detectSubsampling: true,
  behavior: 'move',
  responsive: true

})
